import React from 'react'
import styled from 'styled-components'
import { Heading } from 'sutra/components/Text/Heading'

type Props = { children: React.ReactNode }

export const FormTitle = ({ children }: Props): JSX.Element => (
  <Title>
    <Heading as="h3" $level="4">
      {children}
    </Heading>
  </Title>
)

const Title = styled.div`
  text-align: center;
  margin-bottom: var(--default-padding);

  & > h3 {
    margin-bottom: 12px;
  }
`
